$(document).ready(function(){
	// Request a Repair : Select Your Product
	// LG Repair Dispatch Portal Request Repair : Select Your Product

	if(!document.getElementById('step_select_product')) return false;
	// model search area setting
	var model = {
		el: document.getElementById('step_select_product'),
		search: document.querySelector('form.search-common'), // search area
		select: document.querySelector('form.comboboxForm'), // select area
		errorBlock: null,
		// 20200408 START 구유정 || model.summary selector 변경
		summary: document.querySelector('.model-image-box .model-view-image'),
		// 20200408 END 구유정 || model.summary selector 변경
		confirmed: true, // warranty
		prodType: null, // prodType by categoryId
		passable: true, // next step passable
		// LGEEG-104 START
		passableEg : true, // locale 'EG' next step passable
		// LGEEG-104 END
		warranty: {
			purchase: null,
			criteria: null
		},
		select: {
			el: document.getElementById('productSelectForm'),
			cate: document.getElementById('categoryId'),
			subCate: document.getElementById('subCateId'),
			model: document.getElementById('modelSelector_1')
		},
		summary: document.getElementById('modelSummary'),
		countrycode: document.getElementsByTagName("html")[0].getAttribute("data-countrycode"),
		init: function(){
			model.errorBlock = model.el.querySelector('.error-info-box');
			model.addEvent();
		},
		csMdmsProductCodeInit: function(data){
			// step1 select product | hidden input
			var input = form.el.csMdmsProductCode;
			if(data.csMdmsProductCode && data.csMdmsProductCode != '') {
				if(input) {
					// change
					input.value = data.csMdmsProductCode;
				}else {
					// create
					$(form.el).append('<input type="hidden" name="csMdmsProductCode" value="'+data.csMdmsProductCode+'">');
				}
			} else if(input) {
				// remove
				$(input).remove();
			}
		},
		checkModelType: function(data){
			var $serial = $(form.serial);
			var $msgError = $(form.el).find(".msg-error-oow");
			var $productVersionCode = $(form.productVersionCode);

			// modelType이 변경됨
			if($serial.attr("data-model-type") != data.modelType){
				$serial.attr("data-model-type", data.modelType);
				$msgError.children().hide();
				$(form.submitBtn).show().siblings(".btn-primary.link").hide();
			}

			var isMobileReally = $serial.attr("data-model-type") == "mobile";
			var isMobileSimilar = $serial.attr("ismobile") == "Y"; // mc 제품

			// 국가별 케이스
			switch (model.countrycode) {
				case "pe":
					dp.addEventPE(data);
					break;
				case "ca_en":
				case "ca_fr":
					if(isMobileReally){
						$serial.parents(".write-type").hide();
						$productVersionCode.parents(".write-type").hide();
						$("#serialNumber_by_model").parents(".write-type").hide(); //LGECI-467
						$('input[name=purchasedDate]').addClass('model-mobile'); //LGECI-591
					}else{
						$serial.parents(".write-type").show();
						$productVersionCode.parents(".write-type").show();
						$("#serialNumber_by_model").parents(".write-type").show(); //LGECI-467
						$('input[name=purchasedDate]').removeClass('model-mobile'); //LGECI-591
					}
					$msgError.show();
					dp.addEventCA();
					// 20200527 START 구유정 || 최초 한번 실행하기 추가
					if($(dp.el).val()) $(dp.el).trigger("change");
					// 20200527 END 구유정 || 최초 한번 실행하기 추가
					break;
				case "br":
					// 20200406 START 구유정 || 위치 변경 (개발 요청)
					// 개발 전달용: mc
					form.el.mc.value = $(form.serial).attr("ismobile");
					// 20200406 END 구유정 || 위치 변경 (개발 요청)

					if(form.pageType == "common"){
						if(isMobileSimilar){
							form.resetFormValue($(form.el).find(".only-mc"));
							$(form.symptoms.inputWrap).find(".inner").addClass("full");
							// cluster section
							$(".step-cluster.only-mc").removeClass("disabled")
							$(".step-cluster.other-mc").addClass("disabled")
							// cluster in content
							$(".step-cluster .only-mc").show();
							$(".step-cluster .other-mc").hide();
						}else{
							// 20200323 START 구유정 || br popup guide 변경1
							$(form.submitBtn).attr("data-modal-target", "#repair-step1-policy-pop1"); // yes or default
							// 20200323 END 구유정 || br popup guide 변경1
							$(form.symptoms.inputWrap).find(".inner").removeClass("full");
							// cluster section
							$(".step-cluster.only-mc").addClass("disabled")
							$(".step-cluster.other-mc").removeClass("disabled")
							// cluster in content
							$(".step-cluster .only-mc").hide();
							$(".step-cluster .other-mc").show();
						}
						dp.addEventBR();
					}

					if(form.pageType == "carryin"){
						if(isMobileSimilar){
							// cluster in content
							$(".step-cluster .policy-check.only-mc").show();
							$(".step-cluster .policy-check.other-mc").hide();
						}else{
							// cluster in content
							$(".step-cluster .policy-check.only-mc").hide();
							$(".step-cluster .policy-check.other-mc").show();
						}
					}
					break;
				// default:
				// 	break;
			}
		},
		pasteModelInfo: function(num, url, param){
			form.modelNum.value = num;
			var sum = model.summary;

			ajax.call(url, param, 'json', function(data){

				if(data.csMdmsProductCode && data.csMdmsProductCode != '') {
			
					var serviceInfoForm = document.getElementById("serviceInfoForm");
					
					if(document.getElementById("serviceInfoForm")) {
						
						var setParameter = "csMdmsProductCode="+data.csMdmsProductCode +"&"+ $(form.modelNum).serialize();
						var contactZipCode = document.getElementById('contactZipCode');
						var reservationDate = document.getElementById('reservationDate');
						
						if(contactZipCode) {
							contactZipCode.setAttribute('data-param', setParameter);
							$(reservationDate).attr('data-param', setParameter);
						}
						
                        // LGEIN-471 start
                        var contactPinCode = $("input[id='contactPinCode']");
			/*LGEIN-929 Start*/
                        if( contactPinCode.length > 0) {
                            contactPinCode.attr('data-modelnum', $(form.modelNum).val()).data('modelnum', $(form.modelNum).val());
                            contactPinCode.attr('data-csmdmsproductcode', data.csMdmsProductCode).data('csmdmsproductcode', data.csMdmsProductCode);
                            contactPinCode.attr('data-init', "N").data('init', "N");
                            
                            if( contactPinCode.val() != null && contactPinCode.val() != ""){
                            	contactPinCode.attr('data-init', "Y").data('init', "Y");
                            	$(".pincode-sch").click();
                            }
                        }
			/*LGEIN-929 End*/
                        // LGEIN-471 end
					}
				}else {
					if(form.el.csMdmsProductCode) {
						$(form.el.csMdmsProductCode).remove();
					}
				}

			});
		},
		checkStatus: function(data){
			model.prodType = 'avail';
			model.confirmed = false;

			// 5.0 사용하는곳 없음
			// check prod type
			// var typeList = {
			// 	mobile: ['CT10000028', 'CT10000049', 'CT10000025', 'CT10000027', 'CT30013120', 'CT10000026', 'CT30017745'],
			// 	b2b: ['CT32003205', 'CT32003204', 'CT32003202', 'CT32003206', 'CT32003203', 'CT32003210', 'CT32003208', 'CT32003207'],
			// 	other: ['CT00000180', 'CT00000305', 'CT10000020', 'CT30017684']
			// };
			
			// 5.0 사용하는곳 없음
			// if(typeList.mobile.indexOf(data.categoryId)>=0) {
			// 	model.prodType = 'mobile';
			// }else if(typeList.b2b.indexOf(data.categoryId)>=0){
			// 	model.prodType = 'b2b';
			// }else if(typeList.other.indexOf(data.categoryId)>=0){
			// 	model.prodType = 'other';
			// }else if(data.vipCare == true){
			// 	model.prodType = 'vip';
			// }

			var laborYears = data.hasOwnProperty("warrantyInfoLabor") && data.warrantyInfoLabor ? Number(data.warrantyInfoLabor.replace(/[^0-9]/g,"")) : 0,
				partsYears = data.hasOwnProperty("warrantyInfoParts") && data.warrantyInfoParts ? Number(data.warrantyInfoParts.replace(/[^0-9]/g,"")) : 0;

			model.warranty.criteria = Math.max(laborYears, partsYears);
		},
		addEvent: function(){
			//
		}
	};

	// Purchase / Installation datepicker setting
	var dp = {
		el: null,
		init: function(){
			if(form.el){
				dp.el = form.el.querySelector('.run-datepicker');
			}else{
				return false;
			}
			$(dp.el).datepicker( "option", "maxDate", "0" );
		},
		checkDate: function(){
			var cDateArr = dp.el.value.split(/\.|\/|-/);
			var format = dp.el.getAttribute('data-date-format').toLowerCase().split(/\.|\/|-/);
			var convertFormat = [
				cDateArr[format.indexOf('yy')],
				cDateArr[format.indexOf('mm')],
				cDateArr[format.indexOf('dd')]
			];

			var _cDate = convertFormat.join('-')+"T"+"00:00:00";

			var cDate = new Date(_cDate);
			var today = new Date();

			var $block = $(dp.el).parents('.field-block');

			model.warranty.purchase = cDate;

			if(cDate <= today) {
				$block.removeClass('error');
				return true;
			}else {
				$block.addClass('error').find('.error-msg')
					.find('.invalid').show()
					.siblings().hide();
				return false;
			}
		},
		checkWarranty: function(){
			dp.checkDate();

			var today = new Date(),
				availableDate = new Date(),
				warrantyDate = model.warranty.purchase;
			
			if(model.warranty.criteria > 0) {
				// warranty 기간이 정상값으로 존재하는 경우
				availableDate.setFullYear(warrantyDate.getFullYear() + model.warranty.criteria)
			}else{
				// 예외: warranty 기간이 빈값이거나 음수인 경우
				if(model.countrycode == "ca_en" || model.countrycode == "ca_fr"){
					return false; // CA 법인: out warranty
				}else{
					return true; // CA 법인 제외 GP: in warranty
				}
			}

			if(availableDate >= today){
				return true;
			}else{
				return false;
			}
		},
		addEvent: function(){
			$(form.serial).on("focusout", function(){
				$(this).val( $(this).val().toUpperCase() );
			});
			
		},
		addEventCA: function(){
			$(dp.el).off("change").on("change", function(){
				var $serial = $(form.serial);
				var $msgError = $(form.el).find(".msg-error-oow");

				if(!dp.checkDate()){
					form.targetMsgActivate({
						"$inactiveTarget": $(form.el).find(".msg-error-oow").children(),
						"isBtnActivate": true
					});
					return;
				}

				var isMobileReally = $serial.attr("data-model-type") == "mobile";
				var isMobileSimilar = $serial.attr("ismobile") == "Y"; // mc 제품
				
				var targetSelector;
				var isBtnActivate = true;

				if(dp.checkWarranty()){
					if(isMobileReally){
						targetSelector = ".type-m-in-warranty";
						isBtnActivate = false;
					}else{
						targetSelector = null;
					}
				}else{
					if(isMobileReally){
						targetSelector = ".type-m-out-warranty";
					}else{
						targetSelector = null; //LGECI-591
					}
				}

				var $activeTarget = targetSelector ? $msgError.children(targetSelector) : null;
				var submitBtnLink = $activeTarget ? ( $activeTarget.attr("data-submit-btn-link") || null ) : null;

				form.targetMsgActivate({
					"$activeTarget": $activeTarget,
					"$inactiveTarget": $msgError.children().not(targetSelector),
					"isBtnActivate": isBtnActivate,
					"submitBtnLink": submitBtnLink
				});
				
				/* LGECI-591 Start */
				if(model.countrycode == 'ca_en' || model.countrycode == 'ca_fr') {				
					if($(this).hasClass('model-mobile')) return;
				    var inputDate = new Date($(this).val());
				    var now = new Date();
				    var oneYearAgo = new Date(now.setFullYear(now.getFullYear() - 1));
				    if(inputDate < oneYearAgo){
				        $('#didYouKnow').modal();
				    }
				}
				/* LGECI-591 End */
			});

			$(form.serial).off("change").on("change", function(){
				var $serial = $(form.serial);
				$serial.closest(".field-block").removeClass("error").find(".error-msg span").hide();
			});
		},
		addEventBR: function(){
			$(form.el).off("change", ".only-mc.check-purchased-date input");
			$(form.el).on({
				change: function(){
					// 20200323 START 구유정 || br popup guide 변경2
					if($(this).val() == "-457d"){
						$(form.submitBtn).attr("data-modal-target", "#repair-step1-policy-pop2"); // yes
					}else{
						$(form.submitBtn).attr("data-modal-target", "#repair-step1-policy-pop1"); // no or default
					}
					// 20200323 END 구유정 || br popup guide 변경2
				}
			}, ".only-mc.check-purchased-date input");
		},
		addEventPE: function(data){ /* LGEPE-354 START */
			$(dp.el).off("change").on("change", function(){
				if(model.countrycode == 'pe' && form.pageType == "common") {
					let inputDateArr = $('input[name="purchasedDate"]').val().split('/');
					var inputYear = inputDateArr[2];
					var inputMonth = inputDateArr[1]; 
					var inputDay = inputDateArr[0];
					var inputDate = new Date(inputYear, inputMonth, inputDay);
					
					var now = new Date();			
					var nowYear = now.getFullYear();
					var nowMonth = now.getMonth()+1;
					var nowDay = now.getDate();					
					var nowDate = new Date(nowYear, nowMonth, nowDay);
					
					var diffMs = nowDate.getTime() - inputDate.getTime();
					var diffDay = diffMs / (1000*60*60*24);
					
					if(diffDay > 90 && data.dpMonthBeforeEnableFlag == 'Y') {
						$('#modalDateNoticePE').modal('show');
						$('.select-product-area .field-btn-area .btn-primary').addClass('disabled');
					}else {
						$('.select-product-area .field-btn-area .btn-primary').removeClass('disabled');
					}
				}
			});
		} /* LGEPE-354 END */
	};

	// step 1 form
	var form = {
		el: document.getElementById('stepSelectProduct'),
		pageType: document.querySelector('.step-in-form.request-repair').getAttribute("data-page-type"),
		initialFormValue: null, // 1단계 기본값
		submitBtn: null,
		modelNum: document.getElementById('modelNumber_hidden'),
		// resModelNum: document.getElementById('modelNumber_schedule_hidden'),
		serial: document.getElementById('serialNumber'),
		productVersionCode: document.getElementById('productVersionCode'),
		policyModal: document.querySelectorAll(".repair-modal[id^='repair-step1-policy-pop']"),
		agreeModal: document.getElementById('modalAgreeNotice'), // LGEAF-46 
		$productResult: null,
		$topicArea: null,
		$installModalFlag : true, //LGEEG-142
		$repairModalFlag : true, // LGEEG-274 : 제품 선택 후, 에러 팝업이 뜨는 경우.
		preRepairType: "", //LGEDE-1088
		symptoms: {
			stepWrap: document.getElementById("step_product_issue"),
			inputWrap: null,
			reviewWrap: null,
			topicTemplate: null
		},
		repair: {
			stepWrap: document.getElementById("step_repair_type"),
			tabWrap: null,
			inputWrap: null,
			reviewWrap: null,
			templates: []
		},
		init: function(){
			if(form.symptoms.stepWrap) {
				form.symptoms.inputWrap = form.symptoms.stepWrap.querySelector(".js-input #stepProductIssue");
				form.symptoms.reviewWrap = form.symptoms.stepWrap.querySelector(".js-review");
				form.makeTopicTemplate();
			}

			if(form.repair.stepWrap){
				form.repair.tabWrap = form.repair.stepWrap.querySelector(".js-input .repair-tab-wrap");
				form.repair.inputWrap = form.repair.stepWrap.querySelector(".js-input #repairTypeForm");
				form.repair.reviewWrap = form.repair.stepWrap.querySelector(".js-review");
				document.getElementById("repair-template") && form.makeRepairTemplate();
			}

			// 개발요청
			// 개발 전달용 : repairType, isRealOnsite, isRealInstall, mc, pageType
			!form.el.repairType && $(form.el).append('<input type="hidden" name="repairType">');
			!form.el.isRealOnsite && $(form.el).append('<input type="hidden" name="isRealOnsite">');
			!form.el.isRealInstall && $(form.el).append('<input type="hidden" name="isRealInstall">');
			!form.el.mc && $(form.el).append('<input type="hidden" name="mc">');
			// 20200406 START 구유정 || pageType 추가 (개발요청)
			// 20200421 START 구유정 || STEP1 input initialFormValue 관련 수정
			!form.el.pageType && form.pageType && $(form.el).append('<input type="hidden" name="pageType" data-fixed-value="true" value="'+ form.pageType +'">');
			// 20200406 END 구유정 || pageType 추가 (개발요청)
			// 20200421 END 구유정 || STEP1 input initialFormValue 관련 수정

			// 퍼블 확인용 : productResult
			!form.el.productResult && $(form.el).append('<input type="hidden" name="productResult">');
			form.$productResult = $(form.el.productResult);

			// 20200401 START 구유정 || Phase 4 BR, Phase 4 CN fn 위치변경
			// 20200323 START 구유정 || Phase 4 BR 위치변경
			//LGECL-192,LGEPA-620, LGEEC-88
			if((model.countrycode == "br" || model.countrycode == "cl" || model.countrycode == "cac" || model.countrycode == "cac_en" || model.countrycode == "ec") && form.pageType) {
				form.initBR();
			}
			// 20200323 END 구유정 || Phase 4 BR 위치변경
			// 20200323 START 구유정 || Phase 4 CN 추가
			if(model.countrycode == "cn"){
				form.initCN();
			}
			// 20200323 END 구유정 || Phase 4 CN 추가
			// 20200401 END 구유정 || Phase 4 BR, Phase 4 CN fn 위치변경
			
			form.submitBtn = document.querySelector('.in-step-cluster button');
			form.$topicArea = $(form.symptoms.inputWrap);

			form.setInitialFormValue();
			form.addEvent();
		},
		initBR: function(){
			$("[data-page-content]").each(function(){
				if(this.getAttribute("data-page-content").split("|").indexOf(form.pageType) == -1){
					$(this).remove();
				}
			});
    
			switch (form.pageType) {
				case "common":
					//
					break;
				case "install":
					$(form.symptoms.inputWrap).find(".inner").addClass("full");
					break;
				case "carryin":
					break;
				// default:
				// 	break;
			}
		},
		// 20200323 START 구유정 || Phase 4 CN initCN 추가
		initCN: function(){
			var $productChoiceBox = $(form.el).find(".product-choice-box");

			if($productChoiceBox.length){
				$(form.el).find("#modelNumber_hidden").removeAttr("required");
				
				$(".step-cluster").addClass("active");
				$(".step-cluster .step-head .btn-modify").not(":first").remove();
				$(".step-cluster .field-btn-area button[type='submit']").not(":last").remove();

				var $categoryId = $productChoiceBox.find("#categoryId");
				var $subCateId = $productChoiceBox.find("#subCateId");

				$categoryId.drawAjaxOptions({
					url: $categoryId.data("url"),
					setTarget: $subCateId.get(0)
				});

				form.addEventCN();
			}
		},
		// 20200323 END 구유정 || Phase 4 CN initCN 추가
		makeTopicTemplate: function(){
			var topicCloneHtml;
			var topicCloneObj = $(form.symptoms.inputWrap).find(".combobox").clone();

			topicCloneObj.find("select").chosen('destroy').removeClass('chosen-initialized');
			topicCloneObj.find(".chosen-container").remove();
			topicCloneHtml = topicCloneObj.get(0).innerHTML;

			form.symptoms.topicTemplate = topicCloneHtml;
		},
		makeRepairTemplate: function(){
			var repairTemplate = document.getElementById("repair-template");
			var repairTemplateContent;

			if('content' in document.createElement('template')) {
				// Chrome, Edge, Firefox, Opera, Safari
				repairTemplateContent = repairTemplate.content.querySelectorAll('.repair-content-inner');
			}else{
				// Only Internet Explorer
				repairTemplateContent = repairTemplate.querySelectorAll(".repair-content-inner");
			}

			for (var index=0, length=repairTemplateContent.length, repairTypesAll=[]; index<length; index++) {
				var el = repairTemplateContent[index];
				dataObj = {
					tabTitle: el.getAttribute("data-tab-title") || null,
					typeName: el.getAttribute("data-repair-type"),
					service: el.getAttribute("data-service-type"),
					content: el.getAttribute("data-content-type"),
					country: el.getAttribute("data-country-type") ? el.getAttribute("data-country-type").replace(/ /gi,"").split("|") : null,
					cloneHtml: el.cloneNode(true).innerHTML
				};
				repairTypesAll.push(dataObj);
			}

			var removeIndex = repairTypesAll.map(function(el, index){
				// country가 없을때 continue
				if(!el.country){ return null };
				// 해당 국가 코드 케이스가 아님 (삭제)
				if(el.country.indexOf(model.countrycode) < 0){
					return index;
				}
				// 해당 국가 코드 케이스가 존재함 (GP 케이스는 중복되므로 삭제)
				if(el.country.indexOf(model.countrycode) >= 0){
					for(var i=0; i<repairTypesAll.length; i++){
						if( repairTypesAll[i].country ){ continue } // country가 있을때 continue
						if( repairTypesAll[i].service == el.service && repairTypesAll[i].typeName == el.typeName && repairTypesAll[i].content == el.content ){  
							return i;
						}
					}
				}
			})

			form.repair.templates = repairTypesAll.filter(function(el, index){
				return removeIndex.indexOf(index) < 0;
			});

			$(repairTemplate).remove();
		},
		setInitialFormValue: function(){
			var $elWrap = $(model.el).find(".select-product");
			var $el = $elWrap.find("input:not([type='image']), select, textarea").not(".chosen-search-input");
			var initialFormValue = {};
			$el.each(function(){
				var $this = $(this);
				var id = $this.prop("id");
				var name = $this.attr("name");
				var tagName = $this.prop("tagName");
				initialFormValue[tagName+"-"+name+"-"+id] = {
					// 20200421 START 구유정 || STEP1 input initialFormValue 관련 수정
					// Default: step1의 input, select는 초기 value를 사용하지 않음
					// Exception: step1의 input이 data-fixed-value="true"인 경우, 초기 value를 사용함
					value: tagName == "INPUT" ? ($this.attr("data-fixed-value") == "true" ? $this.val() : "") : ($this.val() || null),
					// 20200421 END 구유정 || STEP1 input initialFormValue 관련 수정
					required: $this.prop("required") ? ($this.get(0).getAttribute("required") !== "false" ? true : null) : null,
					disabled: $this.prop("disabled") || null,
					readonly: $this.prop("readonly") || null,
					checked: $this.prop("checked") || null
				}
			})
			form.initialFormValue = initialFormValue;
		},
		resetFormValue: function($elWrap){
			var $elWrap = $elWrap || $(model.el).find(".select-product");
			var $el = $elWrap.find("input:not([type='image']), select, textarea").not(".chosen-search-input");
			// policy check modal
			$(form.policyModal).data("confirm", false);
			$(form.policyModal).find("input[type='checkbox']").prop("checked",false);
			
			// 법인별 리셋
			switch (model.countrycode) {
				case "ca_en":
				case "ca_fr":
					// 20200527 START 구유정 || CA RESET 관련 추가
					var $msgError = $(form.el).find(".msg-error-oow");
					// 20200527 END 구유정 || CA RESET 관련 추가

					$msgError.children().hide();
					$(form.submitBtn).show().siblings(".btn-primary.link").hide();
					break;
				case "br":
					// 20200323 START 구유정 || br popup guide 변경3
					$(form.submitBtn).attr("data-modal-target", "#repair-step1-policy-pop1"); // no or default
					// 20200323 END 구유정 || br popup guide 변경3
					$(form.symptoms.inputWrap).find(".inner").removeClass("full");

					// cluster section
					$(".step-cluster.only-mc").addClass("disabled")
					$(".step-cluster.other-mc").removeClass("disabled")

					// cluster in content
					$(".step-cluster .only-mc").hide();
					$(".step-cluster .other-mc").show();
					break;
				// default:
				// 	break;
			}

			if(!form.initialFormValue || !$el.length){ return };

			$el.each(function(){
				var $this = $(this);
				var id = $this.prop("id");
				var name = $this.attr("name");
				var tagName = $this.prop("tagName");
				if(form.initialFormValue.hasOwnProperty(tagName+"-"+name+"-"+id)) { // 초기값이 있는 경우
					var prop = form.initialFormValue[tagName+"-"+name+"-"+id];
					if($this.attr("type") !== "radio") $this.val(prop["value"]);
					prop["required"] ? $this.attr("required", "required") : $this.removeAttr("required");
					prop["disabled"] ? $this.attr("disabled", "disabled") : $this.removeAttr("disabled");
					prop["readonly"] ? $this.attr("readonly", "readonly") : $this.removeAttr("readonly");
					prop["checked"] ? $this.prop("checked",true) : $this.prop("checked",false);
				}else{ // 초기값이 없는 경우
					$this.val("");
					$this.prop("checked",false);
					/*LGEIN-929 Start*/
					if($(".step-in-form.require-step").length>0){
						if(tagName=='SELECT'){
							$this.find('option:gt(0)').remove()
						}
					}
					/*LGEIN-929 End*/
				}
				$this.removeAttr("aria-describedby").parents(".field-block").first().removeClass("error").find(".error-msg > span").hide(); // error remove
				$this.hasClass("run-chosen") && $this.trigger('chosen:updated'); // select chosen update
			});

			// 20200421 START 구유정 || model.summary reset 조건 추가, 위치 변경
			// model product image area
			!form.modelNum.value && $(model.summary).hide().siblings(".no-model-select").show();
			// 20200421 END 구유정 || model.summary reset 조건 추가, 위치 변경
		},
		conversionRepairType: function(str){
			switch (str) {
				case "shipin":
					return "shipin";
				case "onsite":
				case "inhome":
					return "onsite";
				case "CI":
					return "carryin";
				case "IS":
					return "installation";
				// default:
				// 	break;
			}
		},
		getProductData: function(ajaxCallbackFn){
			var url = form.el.getAttribute('data-check-repair'),
				param = xssfilter($(form.el).serialize());

			$('body').trigger('ajaxLoadBefore');

			ajax.call(url, param, 'json', function(data){
				$('body').trigger('ajaxLoadEnd');
				if(data) {
					// 개발요청
					// 개발 전달용: repairType, isRealOnsite, isRealInstall
					// repairType: step-repair-type.js: (type이 2개 이상인 경우) tab 선택 시 값이 변경됨
					form.el.repairType.value = data.repairType;
					form.el.isRealOnsite.value = data.isRealOnsite;
					form.el.isRealInstall.value = data.isRealInstall;

					var dataObj = data;
					if(model.countrycode != "hk" && model.countrycode != "hk_en" && model.countrycode != "br"){
						// hk, hk_en이 아닌 GP CASE: CI 제거
						if (dataObj.repairType && dataObj.repairType.indexOf("CI") != -1) {
							dataObj.repairType.splice(dataObj.repairType.indexOf("CI"),1);
						}
					}

					// LGECO-165, LGECL-192 , LGEPA-620 , LGEPE-226, LGEEC-88, LGCOMITF-120
					if(model.countrycode == "br" || model.countrycode == "co" || model.countrycode == "mx" || model.countrycode == "cl" 
						|| model.countrycode == "cac" || model.countrycode == "cac_en" || model.countrycode == "pe" || model.countrycode == "ec"){
						if(dataObj.repairType){
							if(dataObj.repairType.length){
								if(form.pageType == "common"){
									dataObj.repairType = (dataObj.repairType.indexOf("inhome") != -1) ? ["inhome"] : [];
									form.el.repairType.value = (dataObj.repairType.indexOf("inhome") != -1) ? "inhome" : "";
								}else if(form.pageType == "install"){
									dataObj.topic = [];
									dataObj.repairType = (dataObj.repairType.indexOf("IS") != -1) ? ["IS"] : [];
									form.el.repairType.value = (dataObj.repairType.indexOf("IS") != -1) ? "IS" : "";
								}else if(form.pageType == "carryin"){
									dataObj.repairType = (dataObj.repairType.indexOf("CI") != -1) ? ["CI"] : [];
									form.el.repairType.value = (dataObj.repairType.indexOf("CI") != -1) ? "CI" : "";
								}
							}else{
								dataObj.repairType = [];
								form.el.repairType.value = "";
							}
						}
					}
					// LGECO-165, LGECL-192 , LGEPA-620 , LGEPE-226, LGEEC-88, LGCOMITF-120 End

					// 퍼블 확인용
					form.$productResult.data(dataObj);

					if(dataObj.repairType){
						// dataObj.repairType: Request a Repair
                        if(dataObj.repairType.length){
							// 수리 접수 가능
							model.passable = true;
						}else{
							// 수리 접수 불가능
							model.passable = false;
						}
					}else{
						// !dataObj.repairType: Call Appointment
						model.passable = true;
					}
				
					ajaxCallbackFn();
					/*LGEIN-929 Start*/
					if(!model.passable){
						if($(".step-in-form.require-step").length>0 && model.countrycode=="in"){
							form.resetFormValue($(form.symptoms.stepWrap));
						}
						return 
					};
					/*LGEIN-929 End*/

					// 2단계 세팅
					if(form.symptoms.stepWrap){
						form.setFileUpload();
						form.setSmartBanner();
						dataObj.topic && form.setTopicArea();
					}

					// 3단계 세팅
					if(form.repair.stepWrap && dataObj.repairType){
						form.setRepairArea();
					}
				}
			});
		},
		// 20200323 START 구유정 || Phase 4 CN setProductDataCN 추가
		// 20200408 START 구유정 || Phase 4 CN getProductDataCN 변경, ajax 추가(개발요청)
		getProductDataCN: function(dataUrl, $checkedTarget){
			var url = dataUrl;
			var param = $checkedTarget.serialize();

			if(!url) {return};

			$('body').trigger('ajaxLoadBefore');

			ajax.noCacheCall(url, param, 'json', function(data){
				$('body').trigger('ajaxLoadEnd');

				var dataObj = {
					repairType: $($checkedTarget).val() == "ForBtc" ? ["onsite", "IS"] : ["onsite"],
					isRealOnsite: false,
					isRealInstall: false,
					onsiteTimeList: data.hasOwnProperty("onsiteTimeList") ? data.onsiteTimeList : null,
					installTimeList: data.hasOwnProperty("installTimeList") ? data.installTimeList : null,
				};

				// 개발요청
				// 개발 전달용: repairType, isRealOnsite, isRealInstall
				// repairType: step-repair-type.js: (type이 2개 이상인 경우) tab 선택 시 값이 변경됨
				form.el.repairType.value = dataObj.repairType;
				form.el.isRealOnsite.value = dataObj.isRealOnsite;
				form.el.isRealInstall.value = dataObj.isRealInstall;
				
				form.$productResult.data(dataObj);
				form.setRepairArea();
			});
		},
		// 20200323 END 구유정 || Phase 4 CN setProductDataCN 추가
		// 20200408 END 구유정 || Phase 4 CN getProductDataCN 변경, ajax 추가(개발요청)
		setTopicArea: function(){
			var productData = form.$productResult.data();
			var param = $(form.symptoms.inputWrap).attr("data-param");
			var makeOptionList = function($target, obj){
				var htmlStr = '';
				for (var prop in obj) {
					var value = Object.keys(obj[prop])[0];
					var item = obj[prop][value];
					if(prop == null || prop == '') {
						htmlStr += '<option value="'+value+' disabled">'+item+'</option>';
					}else{
						htmlStr += '<option value="'+value+'">'+item+'</option>';
					}
				};
				$target.find("option:disabled").text( xssfilter($target.attr('data-placeholder')) );
				$target.find("option").not(":disabled").remove();
				$target.append(htmlStr);
				$target.trigger('chosen:updated').attr("data-param", param).data("param", param);
			}

			var $topicWrap;
			var $topicWrapEmpty;
			if(model.confirmed){
				if(form.$topicArea.find(".issue-details.select-type .empty-type").length){
					$topicWrap = form.$topicArea.find(".issue-details.select-type .select-type");
					$topicWrapEmpty = form.$topicArea.find(".issue-details.select-type .empty-type");
				}else{
					// LGEEG-274, LGCOMITF-120 : eg_en, eg_ar 대상 클래스 변경(inner => in-box) 적용 건 Call Appointment 페이지 제외
					if((model.countrycode == 'eg_en' || model.countrycode == 'eg_ar')
						&& $(".issue-details.select-type").parents(".in-box").length > 0) {
						$topicWrap = form.$topicArea.find(".issue-details.select-type").parents(".in-box");
						$topicWrapEmpty = $topicWrap.siblings(".in-box");
					} else {
						$topicWrap = form.$topicArea.find(".issue-details.select-type").parents(".inner");
						$topicWrapEmpty = $topicWrap.siblings(".inner");
					}
					// LGEG-274, LGCOMITF-120 End
				}
			}else{
				$topicWrap = form.$topicArea.find(".troubleshoot:not(.bg-gray)");
				$topicWrapEmpty = $topicWrap.siblings(".troubleshoot.bg-gray");
			}

			if(Object.keys(productData.topic).length) {
				$topicWrap.show();
				$topicWrapEmpty.hide();
				if($topicWrap.find('#selectTopic').length){
					makeOptionList($topicWrap.find("select#selectTopic"), productData.topic);
				}
			} else {
				$topicWrap.hide();
				$topicWrapEmpty.show();
				if($topicWrap.find('select').length){
					$topicWrap.find("select").attr("disabled", "disabled");
				}
			}
			// LGEEG-79 Start
			if(model.countrycode == 'eg_en' || model.countrycode == 'eg_ar'){
				if(form.pageType == 'install'){
					$topicWrap.hide();
					if($topicWrap.find('select').length){
						$topicWrap.find("select").attr("disabled", "disabled");
					}
					/* LGEEG-142 Start */
					form.$topicArea.find(".has-upload-box").hide();
					/* LGEEG-142 End */
				}
			}
			// LGEEG-79 End
			
		},
		setFileUpload: function(){
			var productData = form.$productResult.data();
			var $fileInput = $(form.symptoms.inputWrap).find("#file");
			
			if($fileInput.hasClass("fileupload-init")){ return };
			
			productData.multiFileMaxLength && $fileInput.attr("data-multi-length", productData.multiFileMaxLength);
			$fileInput.fileUploadSet();
		},
		setSmartBanner: function(){
			var productData = form.$productResult.data();
			var bannerArea = $(form.symptoms.inputWrap).find(".banner-area") || null; // banner 영역

			// LGEEG-79 Start
			if(!bannerArea || !productData.appliancesBannerFlag || !productData.superCategoryName) {
				if(model.countrycode != "eg_en" || model.countrycode != "eg_ar"){
					if(form.pageType == 'install'){
						bannerArea.hide();
					}//LGETW-714 Start
					else{
						if("tw" == model.countrycode && form.modelNum && "NO_MODEL" == $(form.modelNum).val()){
							bannerArea.hide();
						}
					}
					//LGETW-714 End
				}else {
					// pass
				}
			// LGEEG-79 End
			}else if(model.countrycode != "uk"){
				bannerArea.hide();
			}else if(productData.superCategoryName != "APPLIANCES"){
				bannerArea.hide();
			}else if(productData.appliancesBannerFlag != "Y"){
				bannerArea.hide();
			}else{
				bannerArea.show();
			}
		},
		setRepairArea: function(){
			var productData = form.$productResult.data();
			//var prevRepairType = form.$productResult.val() ? form.$productResult.data("repairType").join(",") : null;
			var prevRepairType = form.preRepairType; // LGEDE-1088
			var currentRepairType = productData.repairType.join(",");
			var isSameProductData = (prevRepairType !== currentRepairType) && (form.el.isRealOnsite.value !== productData.isRealOnsite) && (form.el.isRealInstall.value !== productData.isRealInstall);

			if(isSameProductData){
				form.preRepairType = currentRepairType; // LGEDE-1088
				
				// 제품이 변경되어서 리페어 타입이 변경됨
				var conversionType = productData.repairType.map(function(type){
					return form.conversionRepairType(type)
				});

				// 퍼블 확인용
				form.$productResult
					.data("conversionType", conversionType)
					.val(conversionType.join(","));

				// 3단계 세팅
				form.repair.templates.length && form.setRepairTemplate();
				$(form.repair.inputWrap).trigger("repairType:change"); // step-repair-type.js;
			}else{
				// 제품이 변경되었지만 동일한 리페어 타입을 가짐
				// 3단계 리셋
				$(form.repair.inputWrap).trigger("repairType:reset"); // step-repair-type.js
			}

			$("input[type='radio'][data-active-target]:checked").trigger("toggleRadio:check"); // step-request-control.js
		},
		setRepairTemplate: function(){
			var inputTabArea = $(form.repair.tabWrap).find(".tab-inner");
			var inputContentArea = $(form.repair.inputWrap).find(".repair-content-wrap");
			var inputReviewArea = $(form.repair.reviewWrap).find(".repair-content-wrap");
			
			inputTabArea.html("");
			inputContentArea.html("");
			inputReviewArea.html("");

			var productData = form.$productResult.data();
			var template = productData.conversionType.reduce(templateReducer, []);

			function templateReducer (accumulator, currentValue){
				var repairContent = form.repair.templates.filter(function(item){
					if(currentValue == item.typeName){
						switch (item.typeName) {
							case "onsite":
								return ( productData.isRealOnsite == true ) ? item.service == "real" : item.service == "nonreal";
							case "carryin":
								return ( productData.isRealCarryin == true ) ? item.service == "real" : item.service == "nonreal";
							case "installation":
								return ( productData.isRealInstall == true ) ? item.service == "real" : item.service == "nonreal";
							default:
								return item;
						}
					}
				});
				return accumulator.concat(repairContent);
			};

			template.map(function(item){
				var linkStr = item.typeName + "_" + item.service;
				if(item.content === "input"){
					inputTabArea.append('<a href="#tab-con_'+ linkStr +'" id="tab-tit_' + linkStr + '" class="btn-tab" role="tab">'+ (item.tabTitle ? item.tabTitle : item.typeName) +'</a>');
					// 20200325 START 구유정 || real type 구분값 추가
					inputContentArea.append('<div class="repair-content-inner active" id="tab-con_' + linkStr + '" aria-labelledby="tab-tit_' + linkStr + '" data-service-type="'+ item.service +'">' + item.cloneHtml + '</div>');
					// 20200325 END 구유정 || real type 구분값 추가
				};
				if(item.content === "review"){
					inputReviewArea.append('<div class="repair-content-inner active" data-id="tab-con_' + linkStr + '">' + item.cloneHtml + '</div>');
				};
				
				
			});

			// LGEEG-79,LGEMS-228 , LGECO-165 , LGEPE-226 Start
			if(model.countrycode=='eg_en' || model.countrycode=='eg_ar' || model.countrycode=='mx' || model.countrycode=='co' || model.countrycode=='pe'){
				inputContentArea.removeAttr("role");
				inputTabArea.parent().removeClass("active");
				
				if( model.countrycode=='mx' || model.countrycode=='co' || model.countrycode=='pe'){
					if(form.pageType == 'install'){
						$('#tab-con_onsite_nonreal').removeClass('active');
						$('div[data-id="tab-con_onsite_nonreal"]').removeClass('active');
					}else{
						$('#tab-con_installation_nonreal').removeClass('active');
						$('div[data-id="tab-con_installation_nonreal"]').removeClass('active');
					}
				}
			}else{
				if(productData.conversionType.length >= 2){
					inputContentArea.attr({"role":"tabpanel"});
					inputTabArea.parent().addClass("active");
				}else{
					inputContentArea.removeAttr("role");
					inputTabArea.parent().removeClass("active");
				}
			}
			// LGEEG-79,LGEMS-228 end

			var makeOptionList = function($target, arr){
				var htmlStr = arr.map(function(item){
					return '<option value="'+ item.value +'">' + item.value + '</option>'
				})
				$target.find("option").not(":disabled").remove();
				$target.append(htmlStr.join(""));
			};

			productData.onsiteTimeList && makeOptionList(inputContentArea.find("[id*='onsite_nonreal'] select.reservation-time"), productData.onsiteTimeList);
			productData.installTimeList && makeOptionList(inputContentArea.find("[id*='installation_nonreal'] select.reservation-time"), productData.installTimeList);
			productData.carryinTimeList && makeOptionList(inputContentArea.find("[id*='carryin_nonreal'] select.reservation-time"), productData.carryinTimeList);
		},
		targetMsgActivate: function(obj){
			var $submitBtn = $(form.submitBtn);
			var $linkBtn = $submitBtn.siblings(".btn-primary.link");

			obj.$activeTarget && obj.$activeTarget.show();
			obj.$inactiveTarget && obj.$inactiveTarget.hide();
			
			if(obj.isBtnActivate){
				if(obj.submitBtnLink){
					$linkBtn.attr("href", obj.submitBtnLink).show();
					$submitBtn.hide();
				}else{
					$linkBtn.hide();
					$submitBtn.show();
				}
			}else{
				$linkBtn.hide();
				$submitBtn.hide();
			}
		},
		policyModalCheck: function(modalTarget){
			var status;
			var linkType;
			var $modalTarget = $(modalTarget);

			if(!$modalTarget.data().hasOwnProperty("confirm")){
				status = false;
			}else if($modalTarget.data("confirm") == false){
				status = false;
			}else{
				status = true;
			}

			var isMobileReally = $(form.serial).attr("data-model-type") == "mobile";
			var isMobileSimilar = $(form.serial).attr("ismobile") == "Y"; // mc 제품
			var conversionType = form.$productResult.data("repairType").map(function(type){
				return form.conversionRepairType(type)
			});
			
			// 20200323 START 구유정 || br popup guide 변경4
			if(!conversionType.length){
				status = true;
			}else if(conversionType.indexOf("carryin") > -1){
				linkType = "carryin";
			}else if(conversionType.indexOf("installation") > -1){
				linkType = "common";
			}else if(isMobileSimilar){
				linkType = "mc";
			}else{
				linkType = stepSelectProduct.btbSelector.value == "ForBtc" ? "onsite" : "common";
			}
			// 20200323 END 구유정 || br popup guide 변경4

			$modalTarget.find(".error-msg span").hide();
			$modalTarget.find(".linkChangeWrapper").find("."+linkType).show().siblings().hide();
			
			return status;
		},
		beforeSubmit: function(){
			// whole form validation;
			if($(form.el).checkValidation({trigger:true})) {
				// if( !dp.el || (dp.el && dp.checkDate()) ) { // checkdate 주석처리 (GP 미사용)
					// form.el.submit();
				
					// 한번 실행후 Edit 눌렀을때 true이면 재확인하지 않는 문제가 있어서 수정 함.
					//if(model.confirmed == false) {
					//}

					// 5.0 사용하는곳 없음
					// if(model.confirmed || (!model.confirmed && model.prodType=='avail')) {
					// 	if(model.confirmed && form.resModelNum && form.resModelNum.value != form.modelNum.value) {
					// 		form.resModelNum.value = form.modelNum.value;
					// 		$('#dispatchReservationInquiry .schedule-result-area').html('');
					// 		$('#dispatchzipCode .search-common-input').val('');
					// 		$('button[form="dispatchReservationInquiry"]').attr('disabled','disabled');
					// 	}
					// }
					
				// }
				
				// LGEEG-44 Start
				if(model.countrycode=='eg_en' || model.countrycode=='eg_ar'){
					// LGEEG-142, LGCOMITF-120
					if(form.pageType == 'install' || form.pageType == undefined){
						if(!$(form.symptoms.stepWrap).hasClass('active')) $(form.symptoms.stepWrap).addClass('active');
					}
					// LGEEG-142, LGCOMITF-120 End
					// Check List 로직
					var hiddenCategorySize = $('#stepProductIssue').find('.hidden-size-check-list').length; 
					var tempCategoryId = $('#stepProductIssue').find('.issue-details .combobox select').attr('data-selected-categoryid');
					// LGEEG-79 Start
					if(!tempCategoryId){
						tempCategoryId = $('#categoryId_hidden').val();
					}
					var tempSubCategoryId = $('#stepProductIssue').find('.issue-details .combobox select').attr('data-selected-sub-categoryid');
					if(!tempSubCategoryId){
						tempSubCategoryId = $('#subCategoryId_hidden').val();
					}
					// LGEEG-79 End
					
					// installation만 적용
					if(hiddenCategorySize > 0){
						
						var checkListYn = true;
						var superCategoryCheck=true;
						if(tempSubCategoryId){
							for(var i=1; i<=hiddenCategorySize; i++){
								if($('#stepProductIssue').find('#checkModalCategoryId'+i).val().indexOf(tempSubCategoryId) != -1){
									$('#stepProductIssue').find('.issue-details .check-area .check-location-agree .link-area a').attr('href','#repair-modal'+i);
									$('#stepProductIssue').find('.issue-details .check-area .check-service-agree .link-area a').attr('href','#repair-2-modal'+i);
									$('#stepProductIssue').find('.issue-details .check-list').show();
									superCategoryCheck=false;
									checkListYn=false;
									break;
								}
							}
						}
						if(superCategoryCheck){
							for(var i=1; i<=hiddenCategorySize; i++){
								if($('#stepProductIssue').find('#checkModalCategoryId'+i).val().indexOf(tempCategoryId) != -1){
									$('#stepProductIssue').find('.issue-details .check-area .check-location-agree .link-area a').attr('href','#repair-modal'+i);
									$('#stepProductIssue').find('.issue-details .check-area .check-service-agree .link-area a').attr('href','#repair-2-modal'+i);
									$('#stepProductIssue').find('.issue-details .check-list').show();
									checkListYn=false;
									break;
								}
							}
						}
						if(checkListYn){
							// 등록된 카테고리에 없으면 Check-List 숨김
							$('#stepProductIssue').find('.issue-details .check-list').hide();
						}
						form.symptomCategoryModal(false);
						
						// Sympton 팝업 종료후 로직
						$('#modal_help_library').on('hide.bs.modal', function(event){
							form.symptomCategoryModal(true);
						});
					}
					
					// LGEEG-104 STARAT
					var hiddenProductPassedSize = $('#stepProductIssue').find('.hidden-size-product-passed').length;
					if(hiddenProductPassedSize > 0){
						var superCategoryCheck=true;
						if(tempSubCategoryId){
							for(var i=1; i<=hiddenProductPassedSize; i++){
								if($('#stepProductIssue').find('#selectProductPassedCategoryId'+i).val().indexOf(tempSubCategoryId) != -1){
									superCategoryCheck=false;
									model.passableEg = false;
									break;
								}else{
									model.passableEg = true;
								}
							}
						}
						if(superCategoryCheck){
							for(var i=1; i<=hiddenProductPassedSize; i++){
								if($('#stepProductIssue').find('#selectProductPassedCategoryId'+i).val().indexOf(tempCategoryId) != -1){
									model.passableEg = false;
									break;
								}else{
									model.passableEg = true;
								}
							}
						}
					}
					// LGEEG-104 END
				}
				// LGEEG-44 End
				
				// LGEAF-46 start
				if( $("#modalAgreeNotice").data("useflag") == "Y"){
					$("#modalAgreeNotice").modal();
				}else{
					form.beforeSubmitFnc();
				}
				// LGEAF-46 end
			}
		},
		beforeSubmitFnc: function(){
			// LGEAF-46 start
			var _errorBlock = model.errorBlock;
			switch(model.prodType) {
				case 'mobile':
					adobeTrackEvent('cs-step-request-repair-exception', {cs_product_name : getStepProductCode(), page_event : {repair_product_mobile_device : true}});
					$(_errorBlock.querySelector('.no-available.mobile')).show().siblings().hide();
					$(form.el).trigger('submit:confirmed');
					break;
				case 'b2b':
					adobeTrackEvent('cs-step-request-repair-exception', {cs_product_name : getStepProductCode(), page_event : {repair_product_b2b_product : true}});
					$(_errorBlock.querySelector('.no-available.b2b')).show().siblings().hide();
					$(form.el).trigger('submit:confirmed');
					break;
				case 'vip':
					adobeTrackEvent('cs-step-request-repair-exception', {cs_product_name : getStepProductCode(), page_event : {repair_product_vip_service : true}});
					$(_errorBlock.querySelector('.no-available.vip-care')).show().siblings().hide();
					$(form.el).trigger('submit:confirmed');
					break;
				case 'other':
					adobeTrackEvent('cs-step-request-repair-exception', {cs_product_name : getStepProductCode(), page_event : {repair_product_online_repair : true}});
					$(_errorBlock.querySelector('.no-available.unavailable')).show().siblings().hide();
					$(form.el).trigger('submit:confirmed');
					break;
				case 'avail':
				default:
					var warrantyWrap = null;
					var nonServiceableWrap = null;
					if(_errorBlock){
						var nonServiceables = $(_errorBlock).find(".no-available.non-serviceable");
						// LGEEG-274 Start : 온라인 서비스 불가 시, 에러블럭 클래스 변경 
						if((model.countrycode == "eg_en" || model.countrycode == "eg_ar") && form.pageType != 'install') {
							nonServiceables = $(_errorBlock).find(".service-policy-wrap.inhome-service");
						}
						// LGEEG-274 End
						nonServiceables.each(function(){
							if(this.getAttribute("data-country-type") && this.getAttribute("data-country-type").split("|").indexOf(model.countrycode) > -1){
								nonServiceableWrap = this; // data-country-type 해당 국가 countrycode 존재
							}
						});
						warrantyWrap = _errorBlock.querySelector('.warranty-expired');
						nonServiceableWrap = nonServiceableWrap || nonServiceables.eq(0); // default: first element
					}

					if(warrantyWrap && !$(warrantyWrap).find(".combobox").length) {
						$(warrantyWrap).find(".topic-select-box").addClass("combobox");
					}

					if(!_errorBlock){
						// !_errorBlock: Call Appointment
						model.confirmed = true;
					}else{
						// _errorBlock: Request a Repair
						if(true){
							// GP CASE
							model.confirmed = true;
						}else{
							// GP CASE 없음, warranty in/out check 국가가 생기면 수정 필요
							$(form.symptoms.inputWrap).find(".combobox").html("");
							$(warrantyWrap).find(".combobox").html("");

							// checkWarranty
							if(dp.checkWarranty()) {
								// warranty is not expired
								model.confirmed = true;
								form.$topicArea = $(form.symptoms.inputWrap);
							}else {
								// warranty is expired
								adobeTrackEvent('cs-step-request-repair-exception', {cs_product_name : getStepProductCode(), page_event : {repair_product_warranty_expired : true}});
								model.confirmed = false;
								form.$topicArea = $(warrantyWrap);

								$(warrantyWrap).show().siblings().hide();
							}

							form.$topicArea.find(".combobox").append(form.symptoms.topicTemplate);
							runChosen();
						}
					}

					// 2step topic area init
					$(form.symptoms.inputWrap).trigger("symptoms:topicAreaInit", form.$topicArea);
					
					if(form.el.getAttribute('data-check-repair')) {
						// product data ajax
						form.getProductData(checkModelStatus);
					}else{
						checkModelStatus();
					}

					function checkModelStatus(){
						if($(form.submitBtn).is('[data-modal-target]')){
							var modalTarget = $(form.submitBtn).attr('data-modal-target');
							var policyModalStatus = form.policyModalCheck($(modalTarget));
							
							if(!policyModalStatus){
								$(modalTarget).modal("show");
								return false;
							}
						}
						
						// LGEEG-104, LGEEG-142 START
						// LGEEG-274 Start : if 조건 수정(EG법인, repair, install 구분)
						if(model.confirmed == false) {
							if((model.countrycode == "eg_en" || model.countrycode == "eg_ar")) {
								form.pageType == 'install' ? $('#modalInstallationErrorInfo').modal() : $('#modalRepairErrorInfo').modal();
								form.pageType == 'install' ? $('#installSubmit').prop('disabled', true) : $('#repairSubmit').prop('disabled', true);
							}else{
								$(form.el).trigger('submit:confirmed', [true]);
							}
							$(_errorBlock).show();
						} else if(model.passable == false || model.passableEg == false) {
							$(nonServiceableWrap).show().siblings().hide();
							$(_errorBlock).show();
							
							if((model.countrycode == "eg_en" || model.countrycode == "eg_ar")) {
								form.pageType == 'install' ? $('#modalInstallationErrorInfo').modal() : $('#modalRepairErrorInfo').modal();
								form.pageType == 'install' ? $('#installSubmit').prop('disabled', true) : $('#repairSubmit').prop('disabled', true);
							}else{
								$(form.el).trigger('submit:confirmed', [true]);
							}
						} else {
							$(_errorBlock).hide();
							if((model.countrycode == "eg_en" || model.countrycode == "eg_ar")) {
								form.pageType == 'install' ? form.$installModalFlag = true : form.$repairModalFlag = true; 
								if(form.pageType == 'install') {
									form.symptomCategoryModal(true);
									if(form.$installModalFlag) {
										$('#installSubmit').prop('disabled', false);
									}
								} else {
									if(form.$repairModalFlag) {
										$('#repairSubmit').prop('disabled', false);
										//LGEEG-404 START
										var inputCategoryId = $('#search-keyword_1').attr('data-category');
										var inputSubCategoryId =$('#search-keyword_1').attr('data-subcategory');
										if($('#feesModal_'+inputCategoryId).length > 0) {
											$('#feesModal_'+inputCategoryId).modal();
										} else if($('#feesModal_'+inputSubCategoryId).length > 0) {
											$('#feesModal_'+inputSubCategoryId).modal();
										}
										$('#search-keyword_1').removeAttr('data-category');
										$('#search-keyword_1').removeAttr('data-subcategory');
										//LGEEG-404 END
									}
								}
							}else{
								$(form.el).trigger('submit:confirmed');
							}
						}
						// LGEEG-104, LGEEG-142 END
						// LGEEG-274 End
					}

					break;
			}
			// LGEAF-46 end
		},
		addEvent: function(){
			// "change": model change
			$(form.modelNum).on("change", function(e, data){
				model.csMdmsProductCodeInit(data);
				if(data.modelType && form.serial){
					model.checkModelType(data);
				}

				// LGEGMC-3469 Start 
				// gpSelect-your-product.jsp 국가 개별 파일 다수 > append by js
				$(form.el).find('.serial-purchase-box').prepend('<input type="hidden" name="modelCsSalesCode" id="modelCsSalesCode_hidden" class="modelCsSalesCode_hidden" value="'+ data.csSalesCode +'">');
				// LGEGMC-3469 End
				
				if(model.countrycode == 'in') {
					var param = xssfilter($(model.select.el).serialize());
					var url = model.select.el.action;
					// LGEIN-282 Start 
					var val = data.csSalesCode;
					
                    // LGEIN-314 Start 
                    var serialNumber = data.serialNo;
                    var purchasedDate = data.purchaseDate;
                    
                    if (serialNumber || purchasedDate) {
                        $("#serialNumber").val(serialNumber);
                        $("#purchasedDate").val(purchasedDate);                        
                    }
                    // LGEIN-314 End 
                    
					if (param == "btbSelector=" ){
						param = "categoryId=" + data.categoryId + "&modelNum=" + data.modelName + "&btbSelector=";
					}
					// LGEIN-282 End
					model.pasteModelInfo(val, url, param);
				}
				
				if(model.errorBlock) {
					model.checkStatus(data);
				}

				if(form.symptoms.inputWrap){
					$(form.symptoms.inputWrap).trigger("productIssue:reset");

					var param = "csMdmsProductCode=" + data.csMdmsProductCode + "&" + "categoryId=" + data.categoryId + "&" + "subCateId=" + data.subCateId + "&" + "modelName=" + data.modelName;
					$(form.symptoms.inputWrap).attr("data-param", param).data({"param": param});
					$(form.symptoms.inputWrap).find("#selectTopic").attr("data-param", param).data({"param": param});
					
					$(form.symptoms.inputWrap).find("#selectTopic").attr("data-selected-categoryId", data.categoryId); //LGEEG-45
					$(form.symptoms.inputWrap).find("#selectTopic").attr("data-selected-sub-categoryId", data.subCateId); //LGEEG-45
				}

				// 20200325 START 구유정 || jp no-warranty 추가
				if(model.countrycode == "jp") {
					var $reviewInfo = $(".js-review .model-info");
					if(!data.warrantyInfoLabor && !data.warrantyInfoParts) {
						$reviewInfo.children().first().hide();
						$reviewInfo.children(".no-warranty").show();
					}else{
						$reviewInfo.children().first().show();
						$reviewInfo.children(".no-warranty").hide();
					}
				}
				// 20200325 END 구유정 || jp no-warranty 추가
				
				/* LGEEG-142 Start */
				// LGEEG-274 Start : install 조건 삭제(repair, install 전부 적용
				// LGEEG-404 START
				if((model.countrycode == "eg_en" || model.countrycode == "eg_ar") && form.pageType == 'common' ) {
					$(form.el).submit();
				}else if((model.countrycode == "eg_en" || model.countrycode == "eg_ar") && form.pageType == 'install' ) {
					if(!!$('input[name="purchasedDate"]').val()){
				        $(form.el).submit();
				    }
				}else if(model.countrycode == "in"){//LGEIN-929
					if(!!$('input[name="purchasedDate"]').val()&&!!$('select[name="serviceType"]').val()){
				        $(form.el).submit();
				    }
				}
				// LGEEG-404 END
				// LGEEG-274 End
				/* LGEEG-142 End */
				
			});

			$(form.policyModal).on("submit", "form", function(e){
				e.preventDefault();
				var $this = $(this);
				var $modalWrap = $this.parents(".repair-modal");
				if($this.checkValidation()){
					$modalWrap.data("confirm", true).modal("hide");
					form.beforeSubmit();

					// 기획 변경: 다른 모달도 checked 자동 처리
					$(form.policyModal).find("input[type='checkbox']").prop("checked", true);
					$(form.policyModal).data("confirm", true);
				}else{
					$modalWrap.data("confirm", false);
				}
			});

			$(form.el).on({
				submit: function(e){
					e.preventDefault();
					form.setRequiredAttr(); /* LGEMS-46 20200626 add */
					form.beforeSubmit();
				},
				"selectProduct:reset": function(e){
					e.preventDefault();
					form.resetFormValue();
				}
			});
			
			// LGEAF-46 start
			$(form.agreeModal).on("click", ".modal-content #checkContinue", function(){
				if( $(form.agreeModal).checkValidation({trigger:true})){
					$(form.agreeModal).modal("hide");
					
					if( $("#modalAgreeNotice").data("useflag") == "Y"){
						form.beforeSubmitFnc();
					}
				}
			});
			// LGEAF-46 end
			
			/* LGEEG-142 Start */
			// LGEEG-274 Start : install 조건 삭제(repair, install 전부 적용
			// LGEEG-404 START
			if( (model.countrycode == "eg_en" || model.countrycode == "eg_ar") && form.pageType == 'install') {
				$('input[name=purchasedDate]').on('change', function(){
					 $(form.el).submit();
				});
				}else if(model.countrycode == "in"){//LGEIN-929
				$('input[name=purchasedDate],select[name=serviceType]').on('change', function(){
					 $(form.el).submit();
				});
			}
			// LGEEG-404 END
			/* LGEEG-142 End */
			// LGEEG-274 End
			
			// $(form.submitBtn).on({
			// 	click: function(){
			// 		$(form.el).submit();
			// 	}
			// });
			// LGEEG-404 START
			if( (model.countrycode == "eg_en" || model.countrycode == "eg_ar") && form.pageType == 'common' ) {
				$('#subCatogory_1').on('change', function(){
					var selCategoryId = $('#category_1').val();
					var selSubCategoryId = $('#subCatogory_1').val();
					
					if($('#feesModal_'+selCategoryId).length > 0) {
						$('#feesModal_'+selCategoryId).modal();
					} else if($('#feesModal_'+selSubCategoryId).length > 0 ) {
						$('#feesModal_'+selSubCategoryId).modal();
					}
				});
				$('[id*=feesModal]').on("click", ".modal-content #checkContinue", function(){
					$('[id*=feesModal]').modal("hide");
				});
				$('.predictive-search').on("click", ".list li a", function(){
					var searchCategoryId = $(this).attr('data-category');
					var searchSubCategoryId = $(this).attr('data-subcategory');
					
					$('#search-keyword_1').attr('data-category', searchCategoryId);
					$('#search-keyword_1').attr('data-subCategory', searchSubCategoryId);
				});
			}
			// LGEEG-404 END
		},
		// 20200323 START 구유정 || Phase 4 CN addEventCN 추가
		addEventCN: function(){
			// 20200408 START 구유정 || getProductDataCN trigger event 변경
			$(form.repair.inputWrap).on("init:productData", function(e, obj){
				form.getProductDataCN(obj.dataUrl, obj.$checkedTarget);
			});
			// 20200408 END 구유정 || getProductDataCN trigger event 변경

			$(form.el).on("change", ".product-choice-box #modelNum", function(){
				var value = $(this).val();
				$(form.el).find("#modelNumber_hidden").val(value);
			});
		},
		// 20200323 END 구유정 || Phase 4 CN addEventCN 추가
		/* LGEMS-46 20200626 add */
		setRequiredAttr: function() {
			switch (model.countrycode) {
				case 'mx':
					var $serial = $(form.serial);
					if ($serial.filter('[data-front-required]').length)  {
						var $selectModel = $('#search-keyword_1','#step_select_product');
						$(form.serial).prop('required', ($selectModel.length && !$.trim($selectModel.val())) );
					}
					break;
				default:
					break;
			}
		},
		/* //LGEMS-46 20200626 add */
		// LGEEG-44 Start
		symptomCategoryModal: function(firstCheck){
			/* LGEEG-142 Start */
			if((model.countrycode=='eg_en' || model.countrycode=='eg_ar') && form.pageType == 'install'){
				if(!$(form.symptoms.stepWrap).hasClass('active')) $(form.symptoms.stepWrap).addClass('active');
			}
			/* LGEEG-142 End */
			var hiddenCategorySize = $('#stepProductIssue').find('.hidden-size-check-list').length; 
			// LGEEG-79 Start
			var tempCategoryId = $('#stepProductIssue').find('.issue-details .combobox select').attr('data-selected-categoryid');
			if(!tempCategoryId){
				tempCategoryId = $('#categoryId_hidden').val();
			}
			var tempSubCategoryId = $('#stepProductIssue').find('.issue-details .combobox select').attr('data-selected-sub-categoryid');
			if(!tempSubCategoryId){
				tempSubCategoryId = $('#subCategoryId_hidden').val();
			}
			// LGEEG-79 End
			var hiddenSympCategorySize = $('#stepProductIssue').find('.hidden-size-symp').length; 
			
			// Installation만 적용
			if(hiddenSympCategorySize > 0){
				
				var superCategoryCheck=true;
				if(tempSubCategoryId){
					for(var i=1; i<=hiddenSympCategorySize; i++){
						if($('#stepProductIssue').find('#sympCheckModalCategoryId'+i).val().indexOf(tempSubCategoryId) != -1){
							$('#stepProductIssue').find('.issue-details .check-list').hide();
							if(firstCheck){
								$('#symp-repair-modal'+i).modal();
								/* LGEEG-142 Start */
								if( (model.countrycode=='eg_en' || model.countrycode=='eg_ar') && form.pageType == 'install'){
									form.$installModalFlag = false;
									$('#installSubmit').prop('disabled', true);
								}
								/* LGEEG-142 End */
							}
							superCategoryCheck=false;
							break;
						}
					}
				}
				if(superCategoryCheck){
					for(var i=1; i<=hiddenSympCategorySize; i++){
						if($('#stepProductIssue').find('#sympCheckModalCategoryId'+i).val().indexOf(tempCategoryId) != -1){
							$('#stepProductIssue').find('.issue-details .check-list').hide();
							if(firstCheck){
								$('#symp-repair-modal'+i).modal();
								/* LGEEG-142 Start */
								if( (model.countrycode=='eg_en' || model.countrycode=='eg_ar') && form.pageType == 'install'){
									form.$installModalFlag = false;
									$('#installSubmit').prop('disabled', true);
								}
								/* LGEEG-142 End */
							}
							break;
						}
					}
				}
			}
		}
		// LGEEG-44 End
	}

	model.init(); // select
	dp.init(); // datepicker
	form.init(); // whole form
});